import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createReverifyCurrentEmailOutbound } from '../../api/outbound/reverifyOutbounds';
import { FullScreenModalContainer } from '../../components/fullScreenModalContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { setIsReverifyActionPending, setReverifyPage } from '../../redux/actions/reverifyActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { REVERIFY_PAGE_BUTTONS_CONTAINER_CSS, REVERIFY_PAGE_EMAIL_CSS, REVERIFY_PAGE_USERNAME_CSS } from './reverifyPageConstants';
import { ReverifySkipButtonContainer } from './reverifySkipButtonContainer';
export const ReverifyAskPage = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const username = useAppSelector((state) => state.reverify.username);
    const currentEmail = useAppSelector((state) => state.reverify.currentEmail);
    const isActionPending = useAppSelector((state) => state.reverify.isActionPending);
    const onClickVerifyCurrent = useCallback(() => {
        dispatch(setIsReverifyActionPending(true));
        socketSend(createReverifyCurrentEmailOutbound());
    }, [dispatch, socketSend]);
    const onClickUpdateEmail = useCallback(() => {
        dispatch(setReverifyPage('update-email'));
    }, [dispatch]);
    if (!username || !currentEmail) {
        return null;
    }
    return (_jsxs(FullScreenModalContainer, { title: 'Verify Email Account', children: [_jsxs("div", { children: ["Hey ", _jsx("span", { css: REVERIFY_PAGE_USERNAME_CSS, children: username }), "!"] }), _jsx("div", { children: "To protect your account, please verify your email account." }), _jsxs("div", { children: ["Is your current email ", _jsx("span", { css: REVERIFY_PAGE_EMAIL_CSS, children: currentEmail }), "?"] }), _jsxs("div", { css: REVERIFY_PAGE_BUTTONS_CONTAINER_CSS, children: [_jsx(Button, { onClick: onClickVerifyCurrent, variant: 'contained', disabled: isActionPending, children: "Yes, that's me" }), _jsx(Button, { onClick: onClickUpdateEmail, variant: 'contained', disabled: isActionPending, children: "No, use different email" })] }), _jsx(ReverifySkipButtonContainer, {})] }));
};
